<!-- TODO: refactor colors -->
<!-- @bad TODO: Keyboard navigation-->
<tui-hosted-dropdown
    *tuiLet="fontColor$ | async as selectedColor"
    #color
    [content]="colorDropdown"
    [tuiDropdownMaxHeight]="999"
>
    <button
        tuiIconButton
        type="button"
        size="s"
        icon="tuiIconColorLarge"
        appearance="icon"
        tuiHintDirection="top-left"
        automation-id="toolbar__color-button"
        tuiHintDescribe
        [tuiHint]="foreColorText$ | async"
        [pseudoActive]="color.open"
        [focusable]="color.open"
    ></button>
    <div
        class="t-plate"
        [style.background]="selectedColor"
    ></div>
    <ng-template
        #colorDropdown
        let-activeZone
    >
        <tui-palette
            class="t-color-picker"
            [tuiActiveZoneParent]="activeZone"
            [colors]="colors"
            (selectedColor)="editor.setFontColor($event)"
        ></tui-palette>
    </ng-template>
</tui-hosted-dropdown>
